import React from "react";
import { aboutManagementTeam } from "@/data";

const AboutDirector = ({ extraClassName }) => {

  const { chairMan, viceChairMan, managingDirector } = aboutManagementTeam

  return (
    <section className={`about_section ${extraClassName}`}>
      <div className="container">

        {/* Chairman Section */}
        <div className="main_content add_margin_gap">
          <div className="image_container hide_for_resposive">
            <img src={chairMan?.image} alt="Director" className="chairManImage" />
            <div className="green_overlay1"></div>
            <div className="green_overlay2"></div>
          </div>
          <div className="text_content">
            <h1>Shaileshbhai Patel</h1>
            <h2 className="director_header">Chairman</h2>
            <div className="image_container responsive_display">
              <img src={chairMan?.image} alt="Director" className="chairManImage" />
              <div className="green_overlay1"></div>
              <div className="green_overlay2"></div>
            </div>
            <p>
              Shailesh Patel, Chairman of Greeco Plast, is a visionary leader driving the company's success in the PVC manufacturing industry. With a strong focus on innovation and customer satisfaction, Mr. Patel has guided Greeco Plast to become a leading provider of high-quality PVC products.
            </p>
            <p>
              Under the leadership of Shailesh Patel, Greeco Plast prioritizes sustainability and customer satisfaction. Mr. Patel's dedication to innovation drives the development of eco-friendly and high-performance PVC products.
            </p>
          </div>
        </div>

        {/* Vice Chairman Section */}
        <div className="main_content add_margin_gap">
          <div className="text_content">
            <h1>Pareshbhai Patel</h1>
            <h2 className="director_header">Vice Chairman</h2>
            <div className="image_container responsive_display">
              <img src={viceChairMan?.image} alt="Director" className="viceChairManImage" />
              <div className="green_overlay1"></div>
              <div className="green_overlay2"></div>
            </div>
            <p>
              Paresh Patel, Vice Chairman of Greeco Plast, plays a crucial role in guiding the company's strategic direction and ensuring its continued growth. Mr. Patel brings valuable expertise to the company, contributing to its success in the competitive PVC manufacturing market.
            </p>
            <p>
              As Vice Chairman, Paresh Patel contributes significantly to Greeco Plast's success by fostering innovation and ensuring the company maintains its high standards of quality and customer service.
            </p>
          </div>
          <div className="image_container hide_for_resposive">
            <img src={viceChairMan?.image} alt="Director" className="viceChairManImage" />
            <div className="green_overlay1"></div>
            <div className="green_overlay2"></div>
          </div>
        </div>

        {/* Managing Director */}
        <div className="main_content">
          <div className="image_container hide_for_resposive">
            <img src={managingDirector?.image} alt="Director" className="chairManImage" />
            <div className="green_overlay1"></div>
            <div className="green_overlay2"></div>
          </div>
          <div className="text_content">
            <h1>Dr. Dineshbhai Patel</h1>
            <h2 className="director_header">Managing Director</h2>
            <div className="image_container responsive_display">
              <img src={managingDirector?.image} alt="Director" className="chairManImage" />
              <div className="green_overlay1"></div>
              <div className="green_overlay2"></div>
            </div>
            <p>
              Dr. Dinesh Patel, Managing Director of Greeco Plast, is a key figure in the company's success. With a deep understanding of the PVC industry, Mr. Patel provides strategic direction and oversees all aspects of the business, ensuring the delivery of high-quality products and customer satisfaction.
            </p>
            <p>
              As Managing Director of Greeco Plast, Dr. Dinesh Patel demonstrates strong leadership qualities, guiding the company towards innovation and sustainable growth while fostering a positive and productive work environment.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutDirector;
